import { render, staticRenderFns } from "./QuickNotifications.vue?vue&type=template&id=423f2a9e&scoped=true"
import script from "./QuickNotifications.vue?vue&type=script&lang=js"
export * from "./QuickNotifications.vue?vue&type=script&lang=js"
import style0 from "./QuickNotifications.vue?vue&type=style&index=0&id=423f2a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f2a9e",
  null
  
)

export default component.exports